export type CopyKind = 'complements' | 'associateds';

export interface SourceItem {
  id: number;
  uuid: string;
  id_pdv: number | null;
  sale_name: string | null;
}

export interface CopySource {
  source_type: 'category' | 'product';
  id: number;
  code: number | null;
  name: string | null;
  items: SourceItem[];
}

const normalize = (text: string) =>
  text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

// Busca pelo nome (sem acento/caixa) ou pelo código exato
export const filterSources = (
  sources: CopySource[],
  term?: string
): CopySource[] => {
  const query = normalize(term ?? '');
  if (!query) return sources;

  return sources.filter(
    (source) =>
      normalize(source.name ?? '').includes(query) ||
      String(source.code ?? '') === query
  );
};

// Acrescenta os itens que ainda não estão na lista, sem repetir
export const mergeItems = (
  current: any[] | null | undefined,
  incoming: SourceItem[]
) => {
  const list = Array.isArray(current) ? [...current] : [];
  const seen = new Set(list.map((item) => item?.id));
  let added = 0;

  for (const item of incoming ?? []) {
    if (item?.id == null || seen.has(item.id)) continue;
    seen.add(item.id);
    list.push(item);
    added++;
  }

  return { list, added };
};
